import { useState } from 'react'
import { useTranslation } from '../../i18n'
import './FAQ.css'

function FAQ() {
  const { t } = useTranslation()
  const [openIndex, setOpenIndex] = useState<number | null>(0)

  const faqs = [
    { questionKey: 'homeFaq1Question' as const, answerKey: 'homeFaq1Answer' as const },
    { questionKey: 'homeFaq2Question' as const, answerKey: 'homeFaq2Answer' as const },
    { questionKey: 'homeFaq3Question' as const, answerKey: 'homeFaq3Answer' as const },
    { questionKey: 'homeFaq4Question' as const, answerKey: 'homeFaq4Answer' as const },
    { questionKey: 'homeFaq5Question' as const, answerKey: 'homeFaq5Answer' as const },
  ]

  const toggle = (index: number) => {
    setOpenIndex(openIndex === index ? null : index)
  }

  return (
    <section className="faq-section section" id="faq" aria-label="Frequently asked questions">
      <div className="container">
        <div className="section-title">
          <h2>{t('homeFaqTitle')}</h2>
        </div>

        <div className="faq-list">
          {faqs.map((faq, index) => (
            <div
              key={index}
              className={`faq-item ${openIndex === index ? 'open' : ''}`}
            >
              <button
                className="faq-question"
                onClick={() => toggle(index)}
                aria-expanded={openIndex === index}
              >
                <span>{t(faq.questionKey)}</span>
                <svg
                  className="faq-chevron"
                  width="20"
                  height="20"
                  viewBox="0 0 20 20"
                  fill="none"
                >
                  <path
                    d="M5 7.5L10 12.5L15 7.5"
                    stroke="currentColor"
                    strokeWidth="2"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                  />
                </svg>
              </button>
              <div className="faq-answer">
                <p>{t(faq.answerKey)}</p>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  )
}

export default FAQ
